
import { SearchFlightRecommendation } from '@/types/models';
import { defineComponent, PropType, ref } from 'vue';

import FlightItineraryModal from '@/components/Booking/Flights/Modals/FlightItineraryModal.vue';

import { format } from "date-fns";
import * as Locales from 'date-fns/locale';
import { useStore } from 'vuex';
import { LocaleStrings } from '@/types/paramModels';

export default defineComponent({
    name: "FlightOption",
    components: {
        FlightItineraryModal
    },
    props: {
        flight: {
            type: Object as PropType<SearchFlightRecommendation>,
            required: true
        },
        selectedFlightId: {
            type: String || null,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        pageTexts: {
            type: Object,
            required: true
        },
        isSelectedFlight: {
            type: Boolean
        },
        localeStrings: {
            type: Object as PropType<LocaleStrings>,
            required: true
        }
    },
    setup(_props) {
        const store = useStore();

        const showItinerary = ref(false);

        const openModal = () => {
            showItinerary.value = true;
        }
        const closeModal = () => {
            showItinerary.value = false;
        }

        const formatTotalTravelTime = (dateString: Date | string) => {
            return format(new Date(dateString), "k' " + _props.pageTexts['hotelPageFlightStepModalItineraryHour'] + "'mm '" + _props.pageTexts['hotelPageFlightStepModalItineraryMinute'], { locale: Locales[_props.localeStrings.name] });
        };

        const formatDepartureTime = (dateString: string) => {
            return dateString.slice(dateString.indexOf("T") + 1, dateString.indexOf("T") + 6);
        };

        const formatLongDate = (dateString: Date | string) => {
            return format(new Date(dateString), "do LLLL yyyy", { locale: Locales[_props.localeStrings.name] });
        };

        const updateSelectedFlight = (flight: SearchFlightRecommendation) => {
            store.dispatch('TravelSearchBookingModule/updateSelectedFlight', flight);
        }

        return {
            showItinerary,
            openModal,
            closeModal,
            formatTotalTravelTime,
            formatDepartureTime,
            formatLongDate,
            updateSelectedFlight
        }
    },
})
